/* eslint-disable */

import libraries from '../arduino/libraries'

export default function init(Blockly, profile) {
    Blockly.Arduino.blynk = {};
    Blockly.Arduino.colour_picker = function(block) {
        // Colour picker.
        var code = Blockly.Arduino.quote_(block.getFieldValue('COLOUR'));
        return [code, Blockly.Arduino.ORDER_ATOMIC];
      };
    }